import React, { useState, useEffect } from 'react'
import { message, } from 'antd'
import classnames from 'classnames'
import Icon from '../icon'
import './tagList.less'
import History from './tagList.history'

export default function TagList({ value = new Set(), inputStyle, disabled, onAdd, onDelete, maxSize = 100, className, placement = 'top', ...otherProps }) {
  const [historyVisible, setHistoryVisible] = useState(false)

  useEffect(() => {
    window.addEventListener('mousedown', click)
    return () => window.removeEventListener('mousedown', click)
  }, [])
  const click = () => {
    setHistoryVisible(false)
  }
  const events = {

    // onVisibleChange(visible) {
    //   if (disabled) return
    //   setHistoryVisible(visible)
    // },
    onAddTag: (tag) => {
      if (!tag) {
        return
      }
      if (value.size >= maxSize) {
        message.error(`标签个数不可超过${maxSize}个哦`)
        return
      }
      onAdd?.(tag)
    },
    onClick(e) {
      e.nativeEvent.stopPropagation()
    }
  }
  const visible = !disabled && historyVisible
  return <div className={classnames('mn-add-inspiration-tag-wrapper-old', className)} onMouseDown={events.onClick} {...otherProps}>
    <div className={classnames('tags', { active: visible })}>
      {Array.from(value).map(tag => <span
        key={tag}
        className="tag"
        onClick={() => !disabled && onDelete?.(tag)}
      >{tag}<Icon type="m-guanbi" /></span>)}
      <span className={classnames({ text: true, disabled })} onClick={() => setHistoryVisible(true)}>{visible ? '' : '请点击添加标签'}</span>
    </div>
    <div className={classnames('history-warper', placement)} style={{ display: visible ? 'block' : 'none' }}>
      <History
        value={value}
        visible={visible}
        onClose={() => setHistoryVisible(false)}
        onDelete={tagName => !disabled && onDelete?.(tagName)}
        onAdd={tagName => events.onAddTag(tagName)}
      />
    </div>
  </div>
}
